export default function useSalesforceObjectType(id) {
  let objectType = {
    '001': 'accounts',
    '006': 'opportunities',
    'aCQ': 'product-adoptions',
    '005': 'user'
  }

  return objectType[id.substr(0,3)]
}